import axios from 'axios';
import { FiledLawsuitModel } from 'app/edozvola/cases/filed-lawsuit/model/filed-lawsuit.model';

export const getFiledLawsuit = async (caseUuid: string): Promise<FiledLawsuitModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/filed-lawsuit`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveFiledLawsuit = async (caseUuid: string, filedLawsuit: FiledLawsuitModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/filed-lawsuit`, filedLawsuit)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};
